import { defineComponent as _defineComponent } from 'vue';
import { toRef } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'box-swapping',
    props: {
        currIndex: { default: 0 }
    },
    emits: ['swapping'],
    setup(__props, { emit }) {
        const props = __props;
        /**
         * box-swapping
         * 视频框左右切换icon 组件注入注解
         * 引入方式：<BoxSwapping v-show="singleScreen" :currIndex="selectedBoxIndex" @swapping="handleSwapping" />
         * 支持的props如下：
         * currIndex {number} 当前显示框index
         * 支持的事件如下：
         * swapping 切换视频框事件，传值：false-上一个视频，true-下一个视频
         */
        const DEVICE_MAX_NUM = 4;
        const currIndex = toRef(props, 'currIndex');
        const handleSwapping = (status) => {
            emit('swapping', status);
        };
        return { __sfc: true, DEVICE_MAX_NUM, emit, props, currIndex, handleSwapping };
    }
});
